<template>
<div>

<!--
<div v-if="1==0">
    $store.state.sniffing = 
    {{$store.state.sniffing}}
    <br>
    $store.state.d20200128.openByHour = 
    {{$store.state.d20200128.openByHour}}
    <br>
</div>
-->

  <!--
    
SCG CLUBS
* Ladies Club
* Lady 9ers
* Mens Club
* Mens 9ers
* 150 Club
* Couples

* Closed

# OF HOLES
- 18
- 9




<table>
<tr
        v-for="(h, index) in holesList" 
        :key=index
        >
>

{{h}}

<tr>
    <td>
              @mouseover="mouseOver(index)"
              @mouseout="mouseOut" 
                {{ shortTime(item[1].time) }}<br>

{{$store.state.tableRows[0].teeSheetDate}}

-->


  <OpenByHour2
    v-if="$store.state.loading.length==0"
    :teeSheetDate= "$store.state.sniffing.teeSheetDate"
  />

  <div v-if="1==0">
    <!--
    <OpenByHour
      :teeSheetDate= "$store.state.sniffing.teeSheetDate"
    />>
    -->

    <div v-if="1==0">
      $store.state.sniffing.sniffed = 
      {{$store.state.sniffing.sniffed}} 
      <br>
      teeSheetDate2 = {{$store.state.sniffing.teeSheetDate2}} 
      <br>
      $store.state.openings[0].teeSheetDate2 = 
      {{$store.state.openings[0].teeSheetDate2}} 
      <br>
      $store.state.tableRows[0].teeSheetDate2 = 
      {{$store.state.tableRows[0].teeSheetDate2}} 
      <br>
    </div>


    <br>
    "2020-01-26" = 

    <div v-if="$store.state.d20200126 !=undefined">
      {{$store.state["d20200126"].openings.length}} OPENINGS, 
      <br>
      openings[0] {{$store.state["d20200126"].openings[0]}} 
      </div>
      <div v-else>
        $store.state.d20200126 is undefined
    </div>

    teeSheetDates2 = {{$store.state.sniffing.teeSheetDates2}} 
    <br>


    <p>test targetDate = {{targetDate}}  [{{ chelseaDateToYYYY_MM_DD(targetDate) }}]

      </p>
        <v-layout wrap>
          <v-flex xs3 sm3 md2 lg1 class="mb-1 pl-1 align-content-center text-xs-center">
                  <v-text-field
                    v-model="targetCourse"
                    class="mb-1 mt-0 pt-0 ml-2 pr-1 "
                    style="width: 120px;"
                    height=30
                    dense
                    label="course"
                  ></v-text-field>      
          </v-flex>
          <v-flex xs1 sm1 md1 lg1 class="mb-1 pr-1 pl-1 align-content-center text-xs-center">
                  <v-text-field
                    v-model="targetHole"
                    class="mb-1 mt-0 pt-0 ml-2 pr-1 "
                    style="width: 120px;"
                    height=30
                    dense
                    label="hole"
                  ></v-text-field>      
          </v-flex>
          <v-flex xs2 sm2 md1 lg1 class="text-xs-center mb-1">
                  <v-text-field
                    v-model="targetTime"
                    class="mb-1 mt-0 pt-0 pl-1"
                    height=30
                    dense
                    label="time"
                  ></v-text-field>      
          </v-flex>
          <v-flex xs4 sm3 md2 lg1 class="text-xs-center mb-1">
                  <v-text-field
                    v-model="aTimestamp"
                    class="mb-1 mt-0 pt-0 pl-1"
                    height=30
                    dense
                    label="time"
                  ></v-text-field>    
          </v-flex>

          <v-flex xs12 sm12 md6 lg4 class="text-xs-center mb-1">
              {{aDateTime}}
              <!--
              <br>
              {{timestampToDateTime(aTimestamp)}}
              -->
          </v-flex>


        </v-layout>



    <h3>teeTimeHistory1 for course {{targetCourse}} hole {{targetHole}}  time {{targetTime}}</h3>

    <!-- 
            <ul>
                <li 
                  v-for="(ZtargetHole, index) in holesList" 
                    :key=index>

                    <h5>Hole {{ZtargetHole}}
                      </h5>

            {{teeTimeHistory1(ZtargetHole)}}

    -->

                <v-layout wrap class="mt-2">
                      <v-flex 
                        v-for="(item, index) in teeTimeHistory1" 
                        :key=index
                        class='holeCard tSmaller tC hoverOpening '
                        v-bind:class="classObject3(item[1])"  
                        >
                          {{ shortTime(item[1].time) }}<br>
                          {{ abbrev(item[1].course) }}
                          {{ item[1].hole }}  <span class="players tSmaller">  {{ blankIfZero(item[1].players) }}  </span>  
                          <br>          
                          <span class=" tSmall"> {{ item[0] }} </span>

        {{timestampAge(item[1].timestamp, nowTimestamp).age}}{{timestampAge(item[1].timestamp, nowTimestamp).units}}

                      </v-flex>
                </v-layout>
    <!-- 
                </li>
            </ul>
    -->
        <ul>
            <li 
                v-for="(item, index) in teeTimeHistory1" 
                :key=index>
                    {{ shortTime(item[1].time) }}
                    {{ abbrev(item[1].course) }}
                    {{ item[1].hole }}
                    {{ new Date(item[1].timestamp) }}
                    <br>
            </li>
        </ul>

        {{teeTimeHistory1}}


    <h3>diffedOpenings</h3>

      <v-layout wrap class="mt-2">
            <v-flex 
              v-for="(item, index) in diffedOpenings" 
              :key=index
              class='holeCard tSmaller tC hoverOpening '
              v-bind:class="classObject3(item)"  
              >
                {{ shortTime(item.time) }}<br>
                {{ abbrev(item.course) }}
                {{ item.hole }}  <span class="players tSmaller">  {{ blankIfZero(item.players) }}  </span>  
            </v-flex>
      </v-layout>


    <!--
        <ul>

            <li 
                v-for="(ditem, index) in diffedOpenings" 
                :key=index>
                {{ditem.diff}}

                    {{ shortTime(ditem.time) }}
                    {{ abbrev(ditem.course) }}
                    {{ ditem.hole }}
                    {{ new Date(ditem.timestamp) }}
                    <br>


            </li>
        </ul>

    -->



    <!--



        </td>
    </tr>
    </table>
    -->

    <!-- teeTimeHistory1 {{ teeTimeHistory1 }} -->


    <v-btn 
    @click="alertAnytime">
    ALERT</v-btn>

    <h1>testOpenings lengths</h1>
    testOpenings1 {{testOpenings1.length}}<br>  testOpenings2 {{testOpenings2.length}}<br>  diffedOpenings {{diffedOpenings.length}}<br>   deltaOpenings {{deltaOpenings.length}}<br>  

    <h1>deltaOpenings  {{deltaOpenings.length}} </h1>
    <!--  {{deltaOpenings}} -->

    <h1>diffedOpenings  {{diffedOpenings.length}} </h1>
    <!-- {{diffedOpenings}} -->

    <h1>testOpenings1  {{testOpenings1.length}} </h1>
    <!-- {{testOpenings1}} -->

    <h1>testOpenings2 {{testOpenings2.length}} </h1>
    <!-- {{testOpenings2}} -->
  </div>

</div>
</template>

<script>
  // includes chelseaDateToYYYY_MM_DD()
  import { exampleMixin } from '../mixins/exampleMixin.js'

  //import OpenByHour from './OpenByHour.vue'
  import OpenByHour2 from './OpenByHour2.vue'


  //import { mdiPlus } from '@mdi/js'
  //import { mdiNewBox } from '@mdi/js'
  //import { mdiSettings } from '@mdi/js'

  export default {

    mixins: [exampleMixin],

    components: {
      //OpenByHour, 
      OpenByHour2
    },

    computed: {

        nowTimestamp() { 
          return Number(new Date());
        },
        aDateTime() {
          return new Date(Number(this.aTimestamp))
        },


        diffedOpenings() {
          //alert("diffedOpenings")
            return diffOpenings(this.testOpenings1,this.testOpenings2)
        },

        deltaOpenings() {
            return deltaOpenings(this.diffedOpenings)
        },

        teeTimeHistory1() {

            /*
            const teeSheetDate = "January 26, 2020 - Sunday"
            const hole = "13"
            const course = "North"
            const time = "08:00 AM"
            let targetTeeTime = {}
            targetTeeTime.teeSheetDate = teeSheetDate
            targetTeeTime.hole = hole
            targetTeeTime.course = course
            targetTeeTime.time = time
            */

            //const teeSheetDate = "January 26, 2020 - Sunday"
            //const hole = "02"
            //const course = "Cimarron"
            //const time = "08:00 AM"
            let AtargetTeeTime = {}
            //AtargetTeeTime.teeSheetDate = teeSheetDate
            AtargetTeeTime.teeSheetDate = this.targetDate
            AtargetTeeTime.hole = this.targetHole
            //AtargetTeeTime.hole = hole
            //AtargetTeeTime.course = course
            //AtargetTeeTime.time = time
            AtargetTeeTime.course = this.targetCourse
            AtargetTeeTime.time = this.targetTime
            return this.teeTimeHistory(AtargetTeeTime)
        },

        targetTeeTime() {

            const teeSheetDate = "January 26, 2020 - Sunday"
            //const hole = "02"
            const course = "North"
            const time = "08:00 AM"
            let targetTeeTime = {}
            targetTeeTime.teeSheetDate = teeSheetDate
            targetTeeTime.hole = this.targetHole
            targetTeeTime.course = course
            targetTeeTime.time = time

            return targetTeeTime
        },
        
        XtargetHole() {
            const hole = "01"
            return hole
        },


        holesList() {
            return ["01","02","03","04"]
        }

    },



    methods: {


        timestampAge(t1,t2) {
          const delta = Math.abs(t2-t1)
          let age = delta/1000  // seconds
          let units = "secs"
          age = age/60 // minutes
          units = "mins"

          if (age>600) {
            age = age/60 // hours
            units = "hrs"
          }
          return {"age":Math.round(age),"units":units}
        },


        timestampToDateTime(t) {
            return new Date(Number(t))
        },

        blankIfUndef: function (str) {
            if (str!=undefined) return str
            return ""
        },
            blankIfZero: function (num) {
            if (num===undefined) return ""
            if (num==0) return ""
            return num
        },

        alertAnytime: function () {
            alert("anytime")
        },

        teeTimeHistory: function (targetTeeTime) {

            let historyArr = []
            for ( let i=0; i<this.testOpenings1.length; i++ ) {
                if (areOpeningsEqual(this.testOpenings1[i],targetTeeTime)) {
                    historyArr.push(["SNAP1",this.testOpenings1[i]])
                    console.log("SNAP1",this.testOpenings1[i] )
                }
            }
            for ( let i=0; i<this.deltaOpenings.length; i++ ) {
                if (areOpeningsEqual(this.deltaOpenings[i],targetTeeTime)) {
                    historyArr.push(["DIFF"+this.deltaOpenings[i].diff,this.deltaOpenings[i]])
                }
            }

            for ( let i=0; i<this.testOpenings2.length; i++ ) {
                if (areOpeningsEqual(this.testOpenings2[i],targetTeeTime)) {
                    historyArr.push(["SNAP2",this.testOpenings2[i]])
                }
            }

            return historyArr
        },
                                                            /*
                                                            if (a.course        != b.course      ) return false;
                                                            if (a.hole          != b.hole        ) return false;
                                                            if (a.teeSheetDate  != b.teeSheetDate) return false;
                                                            if (a.time          != b.time        ) return false;
                                                            */

        abbrev: function (str) {
            if (str===undefined) return ""
            return str.substring(0,1)
        },
        shortTime: function (str) {
            if (str===undefined) return ""
            let s = str.substring(0,5)
            if (s.charAt(0)=="0") s=s.substring(1,5)
            return s
        },

        classObject3: function (item) {
              //console.log("classObject",course)
          if (item===undefined) return ""
          //if (item.diff=='+')
          let s = ""
          const course = item.course
          if(course=="South") s += ' cSouth' 
          if(course=="North") s += ' cNorth' 
          if(course=="Desert") s += ' cDesert' 
          if(course=="Cimarron") s += ' cCimarron' 

          if (this.showDiffs || 1==1) {
              if (item.diff!=undefined) {
                if (item.diff=="+") s += " cAdded "
                if (item.diff=="-") s += " cDeleted "
              }
              /*
              if (item.hole=="08") {
                    s += " cAdded "
              }
              if (item.hole=="05") {
                    s += " cDeleted "
              }
              */
          }
          return s
        },

  },


data: () => ({

  targetDate: "January 26, 2020 - Sunday",
  targetHole: "02",
  targetCourse: "Cimarron",
  targetTime: "08:00 AM",
  aTimestamp: null,


  testOpenings1:  [ 
   {
    "captain" : "",
    "course" : "North",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "North",
    "hole" : "02",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "North",
    "hole" : "02",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "02",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "North",
    "hole" : "03",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "03",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "North",
    "hole" : "04",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "04",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "North",
    "hole" : "04",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "04",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "North",
    "hole" : "05",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "05",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "North",
    "hole" : "05",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "05",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "North",
    "hole" : "06",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "06",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "North",
    "hole" : "06",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "06",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "North",
    "hole" : "07",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "07",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "North",
    "hole" : "07",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "07",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "North",
    "hole" : "08",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "08",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "North",
    "hole" : "08",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "08",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "North",
    "hole" : "09",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "North",
    "hole" : "09",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "09",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "North",
    "hole" : "10",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "North",
    "hole" : "10",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "10",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "11",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "North",
    "hole" : "11",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "11",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "12",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "12",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "13",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "North",
    "hole" : "14",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "14",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "North",
    "hole" : "15",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "15",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "North",
    "hole" : "15",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "15",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "North",
    "hole" : "16",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "16",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "16",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Desert",
    "hole" : "10",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:30 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "South",
    "hole" : "10",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:30 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Desert",
    "hole" : "10",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:37 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "South",
    "hole" : "10",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:37 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Desert",
    "hole" : "10",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:45 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "South",
    "hole" : "10",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:45 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Desert",
    "hole" : "10",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:52 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "South",
    "hole" : "10",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:52 AM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "North",
    "hole" : "12",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "12:45 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "South",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "01:30 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "South",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "01:37 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "South",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "01:52 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Desert",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "02:07 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Desert",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "02:15 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "South",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "02:15 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Desert",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "02:22 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "South",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "02:22 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Desert",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "02:30 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "South",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "02:30 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Desert",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "02:37 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "South",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "02:37 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Desert",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "02:45 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "South",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "02:45 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Desert",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "02:52 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "South",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "02:52 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "02",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "03",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "03",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "04",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "04",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "05",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "05",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "06",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "06",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "07",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "07",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "08",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "08",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "09",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "09",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "10",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "10",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "11",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "11",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "12",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "12",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "13",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "13",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "14",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "14",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "15",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "15",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "16",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "16",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "17",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "17",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "18",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "18",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Desert",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:15 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Desert",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:22 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Desert",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:30 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "South",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:30 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Desert",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:37 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "South",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:37 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Desert",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:45 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "South",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:45 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Desert",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:52 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "South",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:52 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Desert",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "04:00 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "South",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "04:00 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Desert",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "04:07 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "South",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "04:07 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Desert",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "04:15 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "South",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "04:15 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Desert",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "04:22 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "South",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "04:22 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Desert",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "04:30 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "South",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "04:30 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Desert",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "04:37 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "South",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "04:37 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Desert",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "04:45 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "South",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "04:45 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "Desert",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "04:52 PM",
    "timestamp" : 1579627819079
  }, {
    "captain" : "",
    "course" : "South",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "04:52 PM",
    "timestamp" : 1579627819079
  } 
],




testOpenings2: [ {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "02",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "03",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "North",
    "hole" : "04",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "North",
    "hole" : "04",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "04",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "North",
    "hole" : "05",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "North",
    "hole" : "05",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "05",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "North",
    "hole" : "06",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "06",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "North",
    "hole" : "06",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "06",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "07",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "North",
    "hole" : "07",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "07",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "North",
    "hole" : "08",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "08",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "North",
    "hole" : "08",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "North",
    "hole" : "09",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "09",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "10",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "North",
    "hole" : "11",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "North",
    "hole" : "11",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "11",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "12",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "12",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "North",
    "hole" : "13",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "13",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "North",
    "hole" : "14",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "14",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "14",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "North",
    "hole" : "15",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "15",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "North",
    "hole" : "15",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "15",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "16",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "North",
    "hole" : "16",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "16",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:00 AM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Desert",
    "hole" : "10",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:30 AM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Desert",
    "hole" : "10",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:37 AM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "South",
    "hole" : "10",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:37 AM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Desert",
    "hole" : "10",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:45 AM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "South",
    "hole" : "10",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "08:45 AM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Desert",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "02:45 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "South",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "02:45 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Desert",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "02:52 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "South",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "02:52 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "02",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "04",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "05",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "05",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "07",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "08",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "08",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "09",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "09",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "10",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "11",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "12",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "13",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "13",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "14",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "14",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "15",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "15",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "16",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "16",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "17",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "17",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "18",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Cimarron",
    "hole" : "18",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:00 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Desert",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:37 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Desert",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:45 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "South",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:45 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Desert",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:52 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "South",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "03:52 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Desert",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "04:00 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "South",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "04:00 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Desert",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "04:07 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "South",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "04:07 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Desert",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "04:15 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "South",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "04:15 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Desert",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "04:22 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "South",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "04:22 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Desert",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "04:30 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "South",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "04:30 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Desert",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "04:37 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "South",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "04:37 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Desert",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "04:45 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "South",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "04:45 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "Desert",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "04:52 PM",
    "timestamp" : 1579881387722
  }, {
    "captain" : "",
    "course" : "South",
    "hole" : "01",
    "player2" : "",
    "player3" : "",
    "player4" : "",
    "players" : 0,
    "teeSheetDate" : "January 26, 2020 - Sunday",
    "time" : "04:52 PM",
    "timestamp" : 1579881387722
  } ],


    }),



  }


function deltaOpenings(diffedOpenings) {
    let res = [];
    for (let i=0; i<diffedOpenings.length; i++) {
      if (diffedOpenings[i].diff!=undefined)
        if (diffedOpenings[i].diff == "-" || diffedOpenings[i].diff == "+" ) {
            res.push(diffedOpenings[i])
        }
    }
    return res
}



function diffOpenings(priorOpenings,currentOpenings) {

    let diffedOpenings = [];
    let oneOpening = {};

    // look at each of the current openings, and see if it is new
    for (let i=0; i<currentOpenings.length; i++) {
        if (isElementInArray( currentOpenings[i], priorOpenings ) ) {
            // this element was there before
            oneOpening = Object.assign({}, currentOpenings[i]);
            oneOpening.diff = "";
            diffedOpenings.push(oneOpening);
            continue;   // so on to the next current opening
        }
        else {
            // element was not there before, so was added
            oneOpening = Object.assign({}, currentOpenings[i]);
            oneOpening.diff = "+";
            diffedOpenings.push(oneOpening);
        }
    }

    // look at each of the prior openings, and see if it is deleted in the current openings
    for (let i=0; i<priorOpenings.length; i++) {
        if (isElementInArray( priorOpenings[i], currentOpenings ) ) {
            // this element was there before
            // so this was already added in the first loop 
            continue;   // so on to the next current opening
        }
        else {
            // element is not there now, so was deleted
            oneOpening = Object.assign({}, priorOpenings[i]);
            oneOpening.diff = "-";
            diffedOpenings.push(oneOpening);
        }
    }

    return diffedOpenings;
}




function areOpeningsEqual(a,b) {
    // assume true until a difference is found
    if (a.course        != b.course      ) return false;
    if (a.hole          != b.hole        ) return false;
    if (a.teeSheetDate  != b.teeSheetDate) return false;
    if (a.time          != b.time        ) return false;
    return true;
}


function isElementInArray(el,arr) {
    for (let j=0; j<arr.length; j++) {
        let res = areOpeningsEqual( el, arr[j] )
        if (res) return true; // element was found in the array
    }
    // was not found, so return false
    return false;
}




</script>


<style scoped>

  .holeCard {
    border: solid 1px;
    padding: 3px;
    color: white;
    width: 40px;
    background-color: lightGray;
  }

  /* styles for the various courses */
  .cNorth {
      background-color: green;
  }
  .cSouth {
      background-color: yellowgreen;
  }
  .cDesert {
      background-color: goldenrod;
  }
  .cCimarron {
      background-color: dodgerblue;
  }
  .cDeleted {
      background-color: lightGray;
  }
  .cAdded {
    /* border: 1px solid red; */
    animation: blink 5s linear infinite;
    outline: 3px solid red;
    outline-offset: -4px;
  }
  .cAdded2 {
    color: red;
  }

  @keyframes blink{
    0%{opacity: .5;}
    25%{opacity: .8;}
    50%{opacity: 1;}
    75%{opacity: .8;}
    100%{opacity: .5;}
  }
  /* https://codepen.io/kocsten/pen/eYOKZVp */

  .players {
    color: red;
  }

  .flex-empty {
    height: 0 !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    
    div {
      width: 150px;
    }
  }
  .flex {
    flex-grow: 0;
  }
  .outlined {
    border: 1px solid;
  }

  .show-btns {
  color: rgba(255, 255, 255, 1) !important;
  }

  .hoverOpening:hover{
    border: 1px solid gray;
    cursor: pointer;
    color: #eee;
  }
                            
</style>